export const QUERIES_KEYS = {
  CURRENT_USER: 'currentUser',
  CURRENT_USER_FROM_CORE: 'currentUserFromCore',
  USER_DATA: 'userData',
  CURRENT_USER_PERMISSIONS: 'currentUserPermissions',
  USER_CONF: 'userConf',
  PHOTO: 'photo',
  LOGIN_OBJECT: 'loginObject',
  RESOURCE_BUNDLE: 'resourceBundle',
  APPLICATION_DATA: 'applicationData',
  GENERAL_SETTINGS: 'generalSettings',
  IS_EXTERNAL_MODE: 'isExternalMode',
  ADMINISTRATORS: 'administrators',
  BULK_ACTIONS_LIMIT: 'bulkActionsLimit',
  EDITION: 'edition',
  GROUPS: 'groups',
  MENU_ITEMS: 'menuItems',
  USER_DETAILS_BY_NAME: 'userDetailsByName',
  USER_DETAILS_BY_ID: 'userDetailsById',
  IS_AI_ENABLED: 'isAiEnabled',
  ENABLED_SWITCH_UI: 'enabledSwitchUi',
  FIELD_ATTRIBUTE: 'fieldAttribute',
};
